import React, { memo, useMemo, useState } from 'react';

import { debounce } from 'lodash';

import Icon from 'components/common/Icons/base/Icon/Icon';

import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/ReportAccessSettings.module.scss';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';

interface Props {
    onSearch: (value: string) => void;
    debounceMs?: number;
    placeholder?: string;
}

const SEARCH_DEBOUNCE_MS = 200;

export const DebouncedSearchInput = memo(
    ({ onSearch, debounceMs = SEARCH_DEBOUNCE_MS, placeholder = 'Search...' }: Props) => {
        const [inputValue, setInputValue] = useState<string>('');

        const debouncedSearch = useMemo(() => debounce(onSearch, debounceMs), [onSearch, debounceMs]);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            setInputValue(value);
            debouncedSearch(value);
        };
        const handleClear = () => {
            setInputValue('');
            onSearch('');
        };

        return (
            <div className={classes.searchInputWrapper}>
                <TextInput
                    value={inputValue}
                    onClear={handleClear}
                    maxLength={200}
                    onChange={handleChange}
                    id={'search-input'}
                    placeholder={placeholder}
                    endIcon={<Icon name={'search'} size={'1.6rem'} color={'var(--text-placeholder)'} />}
                />
            </div>
        );
    },
);
